module.exports = __webpack_public_path__ + "img/article-white.c6d34792.svg";